/**
 * Alnoor — fiche produit : galerie, sélection de variante, packs, commande rapide.
 * Le formulaire "commande rapide" envoie au backend de l'app custom, qui crée
 * une commande COD via l'API Admin Shopify.
 * Endpoint : app proxy Shopify configuré sur /apps/quick-order
 * (voir MIGRATION_PLAN.md § 6.1 pour l'architecture du backend).
 */
(function () {
  var QUICK_ORDER_ENDPOINT = '/apps/quick-order/orders';

  // État partagé : variantes du produit et, pour un pack de plusieurs articles,
  // la variante choisie pour chaque article (null sinon).
  var state = { variants: [], articles: null };

  function formatMoney(amount, currencySymbol) {
    return (amount || 0).toFixed(2) + ' ' + (currencySymbol || '');
  }

  function currencySymbol() {
    return 'DT';
  }

  // Livraison offerte dès un montant (seuil lu sur le formulaire, vient du
  // metafield boutique custom.free_shipping_threshold). Même règle côté backend.
  function applyFreeShipping(subtotal, delivery, threshold) {
    threshold = parseFloat(threshold) || 0;
    return threshold > 0 && subtotal >= threshold ? 0 : delivery;
  }
  function freeShippingHint(el, subtotal, threshold) {
    if (!el) return;
    threshold = parseFloat(threshold) || 0;
    if (threshold <= 0) { el.hidden = true; return; }
    var remaining = threshold - subtotal;
    el.textContent = remaining > 0
      ? 'Plus que ' + formatMoney(remaining, 'DT') + ' pour la livraison offerte'
      : 'Livraison offerte';
    el.classList.toggle('is-reached', remaining <= 0);
    el.hidden = false;
  }
  function deliveryLabel(delivery) {
    return delivery > 0 ? formatMoney(delivery, currencySymbol()) : 'Offerte';
  }

  // Libellé lisible d'une variante. Les couleurs importées de Converty sont des
  // codes hexa (#e1758b) : le nom lisible est alors pris dans le SKU
  // ("...-couleur-rose poudré" -> "rose poudré").
  function variantLabel(v) {
    if (!v) return '';
    var opts = v.options || [];
    var hasHex = opts.some(function (o) { return /^#[0-9a-f]{6}$/i.test(o); });
    if (hasHex) {
      var m = /couleur-([^-]+)$/i.exec(v.sku || '');
      if (m) return m[1].trim();
    }
    return opts.join(' / ');
  }

  // Regroupe les articles d'un pack par variante : [{variant, count}], dans l'ordre.
  function groupArticles(articles) {
    var groups = [];
    articles.forEach(function (v) {
      var g = groups.filter(function (x) { return x.variant.id === v.id; })[0];
      if (g) g.count += 1;
      else groups.push({ variant: v, count: 1 });
    });
    return groups;
  }

  // Met en évidence la valeur choisie dans un groupe de boutons d'option.
  function markGroup(buttons, value) {
    buttons.forEach(function (b) {
      var on = b.dataset.value === value;
      if (b.classList.contains('option-selector--color')) {
        b.classList.toggle('is-selected', on);
        b.style.borderColor = '';
      } else {
        b.classList.toggle('btn--primary', on);
        b.classList.toggle('btn--outline', !on);
      }
    });
  }

  // `variants` : par défaut les variantes du produit principal ; un complément
  // passe les siennes.
  function findVariantByOptions(opts, variants) {
    return (variants || state.variants).filter(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    })[0];
  }

  // ---------------- Disponibilité des options ----------------
  // Une valeur d'option est disponible s'il existe une variante en stock avec
  // cette valeur et les autres options déjà choisies (opts).
  function isOptionAvailable(idx, value, opts, variants) {
    return (variants || state.variants).some(function (v) {
      return v.available && v.options[idx] === value &&
        v.options.every(function (o, i) { return i === idx || o === opts[i]; });
    });
  }

  // Grise, barre et désactive les valeurs en rupture. groups : {index: [boutons]}.
  function refreshAvailability(groups, opts, variants) {
    Object.keys(groups).forEach(function (idx) {
      groups[idx].forEach(function (b) {
        var ok = isOptionAvailable(parseInt(idx, 10), b.dataset.value, opts, variants);
        b.classList.toggle('is-unavailable', !ok);
        b.disabled = !ok;
        b.setAttribute('aria-disabled', ok ? 'false' : 'true');
        b.title = ok ? (b.dataset.value.charAt(0) === '#' ? b.dataset.value : '') : 'Rupture de stock';
      });
    });
  }

  // Choisit une valeur ; si la combinaison obtenue est épuisée, bascule les
  // autres options sur une valeur disponible. Retourne la variante résultante.
  function chooseOption(groups, opts, idx, value, variants) {
    opts[idx] = value;
    Object.keys(groups).forEach(function (key) {
      var j = parseInt(key, 10);
      if (j === idx || isOptionAvailable(j, opts[j], opts, variants)) return;
      var alt = groups[key].filter(function (b) { return isOptionAvailable(j, b.dataset.value, opts, variants); })[0];
      if (alt) opts[j] = alt.dataset.value;
    });
    Object.keys(groups).forEach(function (key) { markGroup(groups[key], opts[key]); });
    refreshAvailability(groups, opts, variants);
    return findVariantByOptions(opts, variants);
  }

  // Commande rapide et barre d'achat mobile : uniquement si la variante est en stock.
  function toggleStockUI(available) {
    ['QuickOrderForm'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.style.display = available ? '' : 'none';
    });
    document.querySelectorAll('.quick-order__sticky-bar').forEach(function (el) {
      el.style.display = available ? '' : 'none';
    });
  }

  // ---------------- Galerie : flèches + vignettes ----------------
  function initGallery() {
    var gallery = document.getElementById('ProductGallery');
    if (!gallery) return;
    var mainImg = document.getElementById('ProductMainImage');
    var videoSlides = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__video-slide'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumb'));
    if (!thumbs.length) return;
    var current = 0;

    function hideAllVideos() {
      videoSlides.forEach(function (slide) {
        slide.style.display = 'none';
        var video = slide.querySelector('video');
        if (video) video.pause();
        var iframe = slide.querySelector('iframe');
        if (iframe) iframe.src = iframe.src; // stop embed playback
      });
    }

    function show(index) {
      current = (index + thumbs.length) % thumbs.length;
      var thumb = thumbs[current];
      thumbs.forEach(function (t) { t.style.borderColor = '#eee'; });
      thumb.style.borderColor = 'var(--color-primary)';

      if (thumb.dataset.type === 'video') {
        mainImg.style.display = 'none';
        hideAllVideos();
        var slide = gallery.querySelector('.product-gallery__video-slide[data-media-index="' + thumb.dataset.index + '"]');
        if (slide) slide.style.display = 'block';
      } else {
        hideAllVideos();
        mainImg.style.display = 'block';
        mainImg.src = thumb.dataset.full;
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });

    var prevBtn = document.getElementById('GalleryPrev');
    var nextBtn = document.getElementById('GalleryNext');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
  }

  function showVariantImage(v) {
    if (!v || !v.featured_image) return;
    var mainImg = document.getElementById('ProductMainImage');
    if (!mainImg) return;
    document.querySelectorAll('.product-gallery__video-slide').forEach(function (s) { s.style.display = 'none'; });
    mainImg.style.display = 'block';
    mainImg.src = v.featured_image;
  }

  // ---------------- Sélection de variante ----------------
  function initVariantSelector() {
    var variantsEl = document.getElementById('ProductVariantsJSON');
    if (!variantsEl) return;
    try {
      state.variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      return;
    }

    var optionGroups = {};
    document.querySelectorAll('#MainOptions .option-selector').forEach(function (btn) {
      var idx = btn.dataset.optionIndex;
      optionGroups[idx] = optionGroups[idx] || [];
      optionGroups[idx].push(btn);
    });

    var selected = [];
    Object.keys(optionGroups).forEach(function (idx) {
      var activeBtn = optionGroups[idx].filter(function (b) {
        return b.classList.contains('is-selected') || b.classList.contains('btn--primary');
      })[0] || optionGroups[idx][0];
      selected[idx] = activeBtn.dataset.value;
    });

    function applyVariant(variant) {
      if (!variant) return;

      document.getElementById('ProductVariantId').value = variant.id;

      var priceEl = document.getElementById('ProductPrice');
      var priceHtml = '';
      if (variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price)) {
        priceHtml += '<s style="color:var(--color-secondary-dark);margin-right:8px;">' + formatMoney(parseFloat(variant.compare_at_price), currencySymbol()) + '</s>';
      }
      priceHtml += formatMoney(parseFloat(variant.price), currencySymbol());
      if (priceEl) priceEl.innerHTML = priceHtml;
      // Un pack est choisi : c'est le prix du pack qui s'affiche.
      if (window.renderPackPrice) window.renderPackPrice();

      var addBtn = document.getElementById('AddToCartButton');
      var addText = document.getElementById('AddToCartText');
      if (addBtn && addText) {
        addBtn.disabled = !variant.available;
        addText.textContent = variant.available ? 'Ajouter au panier' : 'En rupture de stock';
      }

      showVariantImage(variant);
      toggleStockUI(!!variant.available);

      var quickOrderForm = document.getElementById('QuickOrderForm');
      if (quickOrderForm) {
        quickOrderForm.dataset.variantId = variant.id;
        quickOrderForm.dataset.price = variant.price;
        quickOrderForm.dataset.variantLabel = variantLabel(variant);
        if (window.recalcQuickOrder) window.recalcQuickOrder();
      }
    }

    Object.keys(optionGroups).forEach(function (idx) {
      optionGroups[idx].forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          applyVariant(chooseOption(optionGroups, selected, parseInt(idx, 10), btn.dataset.value));
        });
      });
    });
    refreshAvailability(optionGroups, selected);

    var qo = document.getElementById('QuickOrderForm');
    var current = state.variants.filter(function (v) { return String(v.id) === String(document.getElementById('ProductVariantId').value); })[0];
    if (qo && current) qo.dataset.variantLabel = variantLabel(current);
    if (current) toggleStockUI(!!current.available);
  }

  // ---------------- Produits complémentaires ----------------
  // Cases à cocher "Ajoutez X et obtenez N% de remise". Le prix remisé affiché
  // est indicatif : le backend relit le prix de la variante et applique lui-même
  // la remise (même arrondi : centimes, arrondi à l'unité la plus proche).
  var complements = [];

  function discountedPrice(price, pct) {
    var cents = Math.round((parseFloat(price) || 0) * 100);
    return Math.round(cents * (100 - pct) / 100) / 100;
  }

  // Complements cochés avec une variante en stock : total, livraison la plus élevée, lignes.
  function complementsSummary() {
    var out = { count: 0, total: 0, delivery: 0, list: [], items: [] };
    complements.forEach(function (c) {
      if (!c.check.checked || !c.variant || !c.variant.available) return;
      var price = discountedPrice(c.variant.price, c.pct);
      out.count += 1;
      out.total += price;
      out.delivery = Math.max(out.delivery, c.delivery);
      out.list.push({ id: c.id, variant_id: c.variant.id });
      // Les URL Shopify sont relatives au protocole (//cdn...) : la page Merci n'accepte que https://.
      var img = c.variant.featured_image || c.image || '';
      if (img.indexOf('//') === 0) img = 'https:' + img;
      out.items.push({
        title: c.title,
        variant: [variantLabel(c.variant), c.pct > 0 ? 'Complément -' + c.pct + '%' : 'Complément'].filter(Boolean).join(' - '),
        image: img,
        price: price,
        quantity: 1,
      });
    });
    return out;
  }

  function renderComplementPrice(c) {
    var v = c.variant;
    if (!v) return;
    var compare = c.el.querySelector('[data-role="compare"]');
    var price = c.el.querySelector('[data-role="price"]');
    if (compare) compare.textContent = formatMoney(parseFloat(v.price), currencySymbol());
    if (price) price.textContent = formatMoney(discountedPrice(v.price, c.pct), currencySymbol());
    var img = c.el.querySelector('.complement__img');
    if (img && v.featured_image) img.src = v.featured_image;
  }

  function initComplements() {
    document.querySelectorAll('.complement').forEach(function (el) {
      var variantsEl = el.querySelector('.complement__variants');
      var check = el.querySelector('.complement__check');
      if (!variantsEl || !check) return;
      var variants;
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
      var img = el.querySelector('.complement__img');
      var c = {
        el: el, check: check, variants: variants,
        id: el.dataset.complementId,
        title: el.dataset.productTitle,
        pct: parseInt(el.dataset.percent, 10) || 0,
        delivery: parseFloat(el.dataset.delivery) || 0,
        image: img ? img.src : '',
        opts: [], groups: {}, variant: null,
      };
      el.querySelectorAll('.option-selector').forEach(function (btn) {
        var idx = btn.dataset.optionIndex;
        (c.groups[idx] = c.groups[idx] || []).push(btn);
      });
      // Sélection initiale = première variante en stock.
      c.variant = variants.filter(function (v) { return v.available; })[0] || variants[0];
      c.opts = c.variant ? c.variant.options.slice() : [];
      refreshAvailability(c.groups, c.opts, variants);
      renderComplementPrice(c);

      var optionsBox = el.querySelector('.complement__options');
      check.addEventListener('change', function () {
        if (optionsBox) optionsBox.hidden = !check.checked;
        el.classList.toggle('is-checked', check.checked);
        if (window.recalcQuickOrder) window.recalcQuickOrder();
      });
      Object.keys(c.groups).forEach(function (idx) {
        c.groups[idx].forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            c.variant = chooseOption(c.groups, c.opts, parseInt(idx, 10), btn.dataset.value, variants) || c.variant;
            renderComplementPrice(c);
            if (window.recalcQuickOrder) window.recalcQuickOrder();
          });
        });
      });
      complements.push(c);
    });
  }

  // ---------------- Commande rapide ----------------
  function initQuickOrder() {
    var form = document.getElementById('QuickOrderForm');
    if (!form) return;

    var qtyInput = document.getElementById('QuickOrderQty');
    var subtotalEl = document.getElementById('QuickOrderSubtotal');
    var deliveryEl = document.getElementById('QuickOrderDelivery');
    var totalEl = document.getElementById('QuickOrderTotal');
    var stickyTotalEl = document.getElementById('QuickOrderStickyTotal');
    var submitBtn = document.getElementById('QuickOrderSubmit');
    var errorEl = document.getElementById('QuickOrderError');
    var freeShippingEl = document.getElementById('QuickOrderFreeShipping');
    var minusBtn = document.getElementById('QuickOrderQtyMinus');
    var plusBtn = document.getElementById('QuickOrderQtyPlus');

    function recalc() {
      var price = parseFloat(form.dataset.price) || 0;
      var delivery = parseFloat(form.dataset.delivery) || 0;
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var subtotal = price * qty;
      if (form.dataset.bundleId) {
        // Pack choisi : prix, quantité et livraison viennent du pack.
        subtotal = parseFloat(form.dataset.bundlePrice) || 0;
        delivery = parseFloat(form.dataset.bundleDelivery) || 0;
      }
      var comp = complementsSummary();
      subtotal += comp.total;
      if (comp.count) delivery = Math.max(delivery, comp.delivery);
      delivery = applyFreeShipping(subtotal, delivery, form.dataset.freeShippingThreshold);
      var total = subtotal + delivery;
      subtotalEl.textContent = formatMoney(subtotal, currencySymbol());
      deliveryEl.textContent = deliveryLabel(delivery);
      freeShippingHint(freeShippingEl, subtotal, form.dataset.freeShippingThreshold);
      totalEl.textContent = formatMoney(total, currencySymbol());
      if (stickyTotalEl) stickyTotalEl.textContent = formatMoney(total, currencySymbol());
    }
    window.recalcQuickOrder = recalc;

    qtyInput.addEventListener('input', recalc);
    if (minusBtn) minusBtn.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      recalc();
    });
    if (plusBtn) plusBtn.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      recalc();
    });

    submitBtn.addEventListener('click', function () {
      errorEl.style.display = 'none';
      if (window.checkBundleArticles && !window.checkBundleArticles()) return;

      var payload = {
        shop_domain: window.Shopify ? Shopify.shop : '',
        product_id: form.dataset.productId,
        variant_id: form.dataset.variantId,
        bundle_id: form.dataset.bundleId || undefined,
        quantity: parseInt(qtyInput.value, 10) || 1,
        customer: {
          name: document.getElementById('QuickOrderName').value.trim(),
          phone: document.getElementById('QuickOrderPhone').value.trim(),
          city: document.getElementById('QuickOrderCity').value,
          address: document.getElementById('QuickOrderAddress').value.trim(),
        },
      };
      // Pack de plusieurs articles : une variante par article, le backend
      // regroupe par variante et applique le prix du pack.
      if (state.articles) {
        payload.line_items = [{
          product_id: form.dataset.productId,
          bundle_id: form.dataset.bundleId,
          bundle_variants: state.articles.map(function (v) { return v.id; }),
        }];
      }

      if (!payload.customer.name || !payload.customer.phone || !payload.customer.address) {
        errorEl.textContent = 'Merci de remplir le nom, le téléphone et l\'adresse.';
        errorEl.style.display = 'block';
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Envoi en cours…';

      var price = parseFloat(form.dataset.price) || 0;
      var delivery = parseFloat(form.dataset.delivery) || 0;
      var qty = payload.quantity;
      var mainImg = document.getElementById('ProductMainImage');
      var items;
      if (state.articles) {
        var unit = (parseFloat(form.dataset.bundlePrice) || 0) / state.articles.length;
        items = groupArticles(state.articles).map(function (g) {
          return {
            title: form.dataset.productTitle,
            variant: [variantLabel(g.variant), form.dataset.bundleName].filter(Boolean).join(' - '),
            image: g.variant.featured_image || (mainImg ? mainImg.src : ''),
            price: unit,
            quantity: g.count,
          };
        });
        delivery = parseFloat(form.dataset.bundleDelivery) || 0;
      } else {
        var label = form.dataset.variantLabel;
        if (form.dataset.bundleId) {
          price = (parseFloat(form.dataset.bundlePrice) || 0) / qty;
          delivery = parseFloat(form.dataset.bundleDelivery) || 0;
          label = [label, form.dataset.bundleName].filter(Boolean).join(' - ');
        }
        items = [{ title: form.dataset.productTitle, variant: label, image: mainImg ? mainImg.src : '', price: price, quantity: qty }];
      }
      var comp = complementsSummary();
      if (comp.count) {
        items = items.concat(comp.items);
        delivery = Math.max(delivery, comp.delivery);
        payload.complements = comp.list;
      }
      var subtotal = items.reduce(function (s, it) { return s + it.price * it.quantity; }, 0);
      delivery = applyFreeShipping(subtotal, delivery, form.dataset.freeShippingThreshold);

      fetch(QUICK_ORDER_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('request_failed');
          return res.json();
        })
        .then(function (data) {
          var receipt = {
            orderNumber: data.order_number,
            items: items,
            subtotal: subtotal,
            delivery: delivery,
            total: subtotal + delivery,
            customer: payload.customer,
          };
          var encoded = btoa(unescape(encodeURIComponent(JSON.stringify(receipt))));
          window.location.href = '/pages/merci?r=' + encodeURIComponent(encoded);
        })
        .catch(function () {
          errorEl.textContent = 'Une erreur est survenue, merci de réessayer ou de nous contacter.';
          errorEl.style.display = 'block';
          submitBtn.disabled = false;
          submitBtn.textContent = 'Acheter maintenant';
        });
    });

    recalc();
  }

  // ---------------- Packs (bundles) ----------------
  // Même mécanique que Converty : un pack de N articles sur un produit à
  // variantes affiche N sélecteurs ("Article 1", "Article 2"...) à la place du
  // sélecteur principal ; chaque article peut avoir sa propre couleur/taille.
  function initBundles() {
    var selector = document.getElementById('BundleSelector');
    var form = document.getElementById('QuickOrderForm');
    if (!selector || !form) return;
    var qtyInput = document.getElementById('QuickOrderQty');
    var qtyField = document.getElementById('QuickOrderQtyField');
    var mainOptions = document.getElementById('MainOptions');
    var itemsBox = document.getElementById('BundleItems');
    var itemsError = document.getElementById('BundleItemsError');
    var priceEl = document.getElementById('ProductPrice');
    var cards = Array.prototype.slice.call(selector.querySelectorAll('.bundle'));
    var hasOptions = state.variants.length > 1 && mainOptions && itemsBox;

    function currentVariant() {
      var id = String(document.getElementById('ProductVariantId').value);
      return state.variants.filter(function (v) { return String(v.id) === id; })[0] || state.variants[0];
    }

    function renderPackPrice() {
      if (!form.dataset.bundleId || !priceEl) return;
      var p = parseFloat(form.dataset.bundlePrice) || 0;
      var c = parseFloat(form.dataset.bundleCompare) || 0;
      priceEl.innerHTML = (c > p ? '<s style="color:var(--color-secondary-dark);margin-right:8px;">' + formatMoney(c, currencySymbol()) + '</s>' : '') + formatMoney(p, currencySymbol());
    }
    window.renderPackPrice = renderPackPrice;

    function checkArticles() {
      if (!state.articles) {
        if (itemsError) itemsError.style.display = 'none';
        return true;
      }
      var bad = [];
      state.articles.forEach(function (v, i) { if (!v || !v.available) bad.push(i + 1); });
      if (bad.length) {
        itemsError.textContent = 'Article ' + bad.join(', ') + ' : ce choix n\'est pas disponible, merci d\'en choisir un autre.';
        itemsError.style.display = 'block';
        return false;
      }
      itemsError.style.display = 'none';
      return true;
    }
    window.checkBundleArticles = checkArticles;

    function buildArticles(n) {
      var base = currentVariant();
      state.articles = [];
      itemsBox.innerHTML = '';
      for (var i = 0; i < n; i++) {
        (function (i) {
          var opts = base.options.slice();
          state.articles.push(base);
          var wrap = document.createElement('div');
          wrap.className = 'bundle-item';
          var title = document.createElement('p');
          title.className = 'bundle-item__title';
          title.textContent = 'Article ' + (i + 1);
          wrap.appendChild(title);
          var groups = {};
          mainOptions.querySelectorAll('.option-group').forEach(function (group) {
            var idx = parseInt(group.dataset.optionIndex, 10);
            var clone = group.cloneNode(true);
            var btns = Array.prototype.slice.call(clone.querySelectorAll('.option-selector'));
            groups[idx] = btns;
            markGroup(btns, opts[idx]);
            btns.forEach(function (b) {
              b.addEventListener('click', function () {
                if (b.disabled) return;
                var v = chooseOption(groups, opts, idx, b.dataset.value);
                state.articles[i] = v || null;
                showVariantImage(v);
                checkArticles();
              });
            });
            wrap.appendChild(clone);
          });
          refreshAvailability(groups, opts);
          itemsBox.appendChild(wrap);
        })(i);
      }
      mainOptions.hidden = true;
      itemsBox.hidden = false;
      checkArticles();
    }

    function clearArticles() {
      state.articles = null;
      if (itemsBox) { itemsBox.hidden = true; itemsBox.innerHTML = ''; }
      if (mainOptions) mainOptions.hidden = false;
      if (itemsError) itemsError.style.display = 'none';
    }

    function select(card) {
      cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
      form.dataset.bundleId = card.dataset.bundleId;
      form.dataset.bundleName = card.dataset.bundleName;
      form.dataset.bundlePrice = card.dataset.bundlePrice;
      form.dataset.bundleCompare = card.dataset.bundleCompare;
      form.dataset.bundleDelivery = card.dataset.bundleDelivery;
      form.dataset.bundleQuantity = card.dataset.bundleQuantity;
      qtyInput.value = card.dataset.bundleQuantity;
      qtyInput.readOnly = true;
      if (qtyField) qtyField.style.display = 'none';
      var n = parseInt(card.dataset.bundleQuantity, 10) || 1;
      if (hasOptions && n > 1) buildArticles(n);
      else clearArticles();
      renderPackPrice();
      if (window.recalcQuickOrder) window.recalcQuickOrder();
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { select(card); });
    });

    // "Ajouter au panier" avec un pack : propriété cachée _bundle_id (le prix du
    // pack est appliqué dans le panier et recalculé côté serveur à la commande).
    // Pack de plusieurs articles : une ligne par variante, reliées entre elles
    // par _bundle_group pour que le panier les traite comme un seul pack.
    var addForm = document.getElementById('ProductForm');
    if (addForm) {
      addForm.addEventListener('submit', function (e) {
        if (!form.dataset.bundleId) return;
        e.preventDefault();
        if (!checkArticles()) return;
        var items;
        if (state.articles) {
          var group = 'p' + Date.now().toString(36);
          items = groupArticles(state.articles).map(function (g) {
            return { id: g.variant.id, quantity: g.count, properties: { _bundle_id: form.dataset.bundleId, _bundle_group: group } };
          });
        } else {
          items = [{
            id: parseInt(document.getElementById('ProductVariantId').value, 10),
            quantity: parseInt(form.dataset.bundleQuantity, 10) || 1,
            properties: { _bundle_id: form.dataset.bundleId },
          }];
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add_failed');
            window.location.href = '/cart';
          })
          .catch(function () {
            alert('Impossible d\'ajouter ce pack au panier, merci de réessayer.');
          });
      });
    }
    select(cards.filter(function (c) { return c.classList.contains('is-selected'); })[0] || cards[0]);
  }

  // ---------------- Pixel Facebook : AddToCart ----------------
  // Enregistré avant initBundles : il part avant l'ajout (même quand un pack est ajouté en AJAX).
  function initTracking() {
    var addForm = document.getElementById('ProductForm');
    var qo = document.getElementById('QuickOrderForm');
    if (!addForm || !qo) return;
    addForm.addEventListener('submit', function () {
      try {
        if (!window.fbq) return;
        var value = qo.dataset.bundleId ? parseFloat(qo.dataset.bundlePrice) : parseFloat(qo.dataset.price);
        fbq('track', 'AddToCart', {
          content_type: 'product',
          content_ids: [String(qo.dataset.productId)],
          content_name: qo.dataset.productTitle,
          value: value || 0,
          currency: 'TND'
        });
      } catch (e) {}
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initVariantSelector();
    initComplements();
    initQuickOrder();
    initTracking();
    initBundles();
  });
})();
